var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hub-select"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.$t(_vm.label)))]):_vm._e(),_c('v-select',_vm._b({ref:"tdd-hub-select",class:{
      'hub-select-outline': _vm.outline,
      'hub-select-pill': _vm.pill,
    },attrs:{"aria-label":"Select component","dense":"","height":_vm.height,"items":_vm.items,"menu-props":{
      allowOverflow: true,
      auto: false,
      contentClass: 'hub-select-options',
      offsetY: true,
      maxHeight: 200,
    },"outlined":""},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},'v-select',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }